<template>
    <z-filter name="Программы на старте карьеры">
        <z-filter-content
            @update-params="onFilterChange"
            v-model="filterParams"
            :structure="structure"
        />
    </z-filter>
</template>

<script setup>
import { useFiltersParams } from '@/composable/useFilter';

const emit = defineEmits(['updateParams'])
const props = defineProps({
    filter: Object
})

const structure = {
    'study-place': {
        'type': 'z-select',
        value: '',
        props: {
            title: 'Место учебы',
        },
        'class': 'col-default-3 col-v-tablet-12'
    },
    'course': {
        'type': 'z-select',
        value: '',
        props: {
            title: 'Курс в вузе',
        },
        'class': 'col-default-3 col-v-tablet-12'
    },
    'certificate': {
        'type': 'z-select',
        value: '',
        props: {
            title: 'Удостоверения рабочей профессии',
        },
        'class': 'col-default-3 col-v-tablet-12'
    },
    participant: {
        'type': 'z-select',
        value: '',
        props: {
            title: 'Участник проектов ИНК',
        },
        'class': 'col-default-3 col-v-tablet-12'
    },
    'direction': {
        'type': 'z-select',
        value: '',
        props: {
            title: 'Направление подготовки',
        },
        'class': 'col-default-6 col-v-tablet-12'
    },
    'program-place': {
        'type': 'z-select',
        value: '',
        props: {
            title: 'Место программы',
        },
        'class': 'col-default-3 col-v-tablet-12'
    },
    'paid-internship': {
        'type': 'z-select',
        value: '',
        props: {
            title: 'Оплачиваемая практика',
        },
        'class': 'col-default-3 col-v-tablet-12'
    },
}

Object.keys(props.filter).forEach(key => {
    const options = props.filter[key];

    structure[key].props.size = 'm';
    structure[key].props.options = options;
    structure[key].props.placeholder = 'Все';
})

const filterParams = useFiltersParams(structure);

const onFilterChange = (data) => {
    emit('updateParams', data)
}
</script>

<style lang="scss">

</style>